import styled from '@emotion/styled';
import { useTranslationWithPrefix } from '@hotjar/translations';
import { Button, Stack } from '@hotjar/hotsauce';
import type { WizardStep, WizardSectionKey } from '../../../../../domain/common/Wizard/Wizard';

const FooterContainer = styled(Stack)``;

export const StepFooter = ({ step }: { step: WizardStep<WizardSectionKey> }): JSX.Element => {
  const { t } = useTranslationWithPrefix('feedback:wizard.action');

  return (
    <FooterContainer>
      {step.isDone ? (
        <Button onClick={step.onDone}>{t('done')}</Button>
      ) : (
        <Button onClick={step.onNext}>{t('next')}</Button>
      )}
    </FooterContainer>
  );
};
